import React from "react";
import { Home, Zap, Image, MapPin, Info } from "lucide-react";
import "./sidebar.css";

const items = [
  { id: "hero", label: "Início", icon: Home },
  { id: "como-usar", label: "Como Usar", icon: Zap },
  { id: "galeria", label: "Galeria", icon: Image },
  { id: "localizacao", label: "Localização", icon: MapPin },
  { id: "footer", label: "Contato", icon: Info },
];

export default function Sidebar({ onNavigate }) {
  return (
    // sempre colapsado (ícones apenas)
    <aside
      className="mobon-sidebar collapsed"
      role="navigation"
      aria-label="MOB-ON Menu"
    >
      {/* título oculto, mantido para acessibilidade */}
      <div className="mobon-sidebar__title sr-only">MOB-ON Menu</div>

      <nav className="mobon-sidebar__menu">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <button
              key={it.id}
              className="mobon-sidebar__btn"
              onClick={() => onNavigate && onNavigate(it.id)}
              title={it.label}
              aria-label={it.label}
              type="button"
            >
              <Icon className="mobon-sidebar__icon" />
              {/* texto visualmente escondido, útil para leitores de tela */}
              <span className="sr-only">{it.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
